import { Component, AfterViewInit } from '@angular/core';
import * as Highcharts from 'highcharts';
import { SkillRepoEmployeesService } from '../../skill-repo-employees/skill-repo-employees.service';
import { ActivatedRoute, Router } from '@angular/router';
import { OthersService } from '../others/othersDataService';
import { SharedSkillService } from '../../skill-repository/shared-skill.service';
import { log } from 'console';
import { CompetenciesService } from '../competencies.service';


@Component({
  selector: 'app-certifications',
  templateUrl: './certifications.component.html',
  styleUrls: ['./certifications.component.css']

})

export class CertificationsComponent implements AfterViewInit {

  ngAfterViewInit() {
  this.handleNameChange();
  }

  initchart(){

    this.totalCount = this.certificateWidgetData?.completedCertificateCount + this.certificateWidgetData?.pendingCertificateCount
    var num = this.totalCount;

    function getSubtitle() {
      return `<span style="font-size: 16px"> ${num}</span>`;
    }
    Highcharts.chart('chartContainer', {
      chart: {
        type: 'pie',
        backgroundColor: 'transparent',
        width: 130,
        height: 100,
      },
      title: {
        text: null
      },
      credits: {
        enabled: false

      },
      subtitle: {
        useHTML: true,
        text: getSubtitle(),
        floating: true,
        verticalAlign: 'top',
        y: 60,

      },
      plotOptions: {
        pie: {
          innerSize: '70%',
          dataLabels: {
            enabled: false

          }

        },
      },
      colors: ['#54bb83', '#183b8c'],
      series: [
        {
          type: 'pie',
          name: 'Certifications',
          data: [
            ['Planned Certifications', this.certificateWidgetData?.pendingCertificateCount??0],
            ['Completed Certifications', this.certificateWidgetData?.completedCertificateCount??0]
          ]
        }
      ]

    });
  }
  competencyname: any;
  name: string;
  compId: number;
  certificate: number = 2;
  subCompetencyid: any;
  subCompetencyName: any
  certificateWidgetData: any
  totalCount: number;
  constructor(private sharedskillservice: SharedSkillService, private skillservice: SkillRepoEmployeesService, private route: ActivatedRoute, private compservice: CompetenciesService, private othersService: OthersService, private router: Router) { }

  ngOnInit() {
    this.compservice.profileStatus$.subscribe(x => {
      this.compId = x
      if (this.compId == null) {
        this.compId = Number(sessionStorage.getItem("compId"))
      }
    })
    this.compservice.competencyName$.subscribe(x => {
      this.competencyname = x
      if (this.competencyname == null || this.competencyname == "") {
        this.competencyname = sessionStorage.getItem("compTitle")
      }
    })

    this.othersService.id$.subscribe(id => {
      this.subCompetencyid = id;
      if (this.subCompetencyid == null || this.subCompetencyid == 0) {
        this.subCompetencyid = Number(sessionStorage.getItem("SubcompId"))
      }
    });

    this.othersService.name$.subscribe(name => {
      this.subCompetencyName = name;
      if (this.subCompetencyName == null || this.subCompetencyName == "") {
        this.subCompetencyName = sessionStorage.getItem("SubcompTitle")
      }

    });
  }

  navigateToPartnershipGrid(): void {
    var url=this.router.url.split('/')
    var navurl = decodeURIComponent(url[3])+'/partnership-grid';
    this.router.navigate([url]);
  }
  handleNameChange() {
    //this.getCertificateWidgetCount();
    this.compservice.serviceId$.subscribe(serviceId => {
      if (serviceId) {
        this.getCertificateWidgetCount(serviceId);
      }
    });

  }

  getCertificateWidgetCount(serviceId: number) {
    this.compservice.GetCertificateWidgetCount(this.compId, serviceId).subscribe(res => {
      this.certificateWidgetData = res.data;
      this.initchart();
    })
  }
  planned() {

    let filter = 1;
    sessionStorage.setItem("resource", String(this.certificate))
    sessionStorage.setItem("filter", String(filter))
    this.sharedskillservice.setpagenavigationId({
      resource: this.certificate,
      competencyId: this.compId,
      options: filter,
      competencyName: this.competencyname,
      subCompId: this.subCompetencyid
    });
    this.skillservice.certificateroute(this.competencyname, this.subCompetencyid, this.subCompetencyName, filter)

  }
  completed() {
    let filter = 2;
    sessionStorage.setItem("resource", String(this.certificate))
    sessionStorage.setItem("filter", String(filter))
    this.sharedskillservice.setpagenavigationId({
      resource: this.certificate,
      competencyId: this.compId,
      options: filter,
      competencyName: this.competencyname,
      subCompId: this.subCompetencyid
    });
    this.skillservice.certificateroute(this.competencyname, this.subCompetencyid, this.subCompetencyName, filter)
  }
}
